"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _react = _interopRequireWildcard(require("react"));

var _reactRedux = require("react-redux");

var _reactHookForm = require("react-hook-form");

var _query = require("@reduxjs/toolkit/query");

var _ui = require("@alycecom/ui");

var _material = require("@mui/material");

var _services = require("@alycecom/services");

var _ramda = require("ramda");

var _messaging = require("../../constants/messaging.schema");

var _providers = require("../../../../providers");

var _MessageDataController = _interopRequireDefault(require("../MessageDataController/MessageDataController"));

var _messaging2 = require("../../constants/messaging.types");

var _RecipientActions = _interopRequireDefault(require("../RecipientActions"));

var _commonData = require("../../../../../Shared/store/commonData/commonData.selector");

var _MeetingHostsController = _interopRequireDefault(require("../MeetingHostsController"));

var _VideoDataController = _interopRequireDefault(require("../VideoDataController/VideoDataController"));

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0, _defineProperty2.default)(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

var MessagingForm = function MessagingForm(_ref) {
  var children = _ref.children,
      isMessagingPending = _ref.isMessagingPending,
      isGiftsCreatePending = _ref.isGiftsCreatePending,
      onSubmit = _ref.onSubmit;

  var _useGiftingFlowContex = (0, _providers.useGiftingFlowContext)(),
      batchId = _useGiftingFlowContex.batchId;

  var _useGetProspectingBat = (0, _services.useGetProspectingBatchByIdQuery)(batchId ? {
    batchId
  } : _query.skipToken),
      batch = _useGetProspectingBat.data;

  var _useGetCampaignByIdQu = (0, _services.useGetCampaignByIdQuery)((batch === null || batch === void 0 ? void 0 : batch.campaignId) || _query.skipToken),
      campaign = _useGetCampaignByIdQu.data;

  var bodyCharsLimit = (0, _reactRedux.useSelector)(_commonData.getEmailCharLimit);

  var _useForm = (0, _reactHookForm.useForm)({
    mode: 'all',
    resolver: _messaging.messagingFormResolver,
    defaultValues: _messaging.messagingFormDefaultValues,
    context: {
      bodyCharsLimit
    }
  }),
      handleSubmit = _useForm.handleSubmit,
      control = _useForm.control,
      reset = _useForm.reset,
      resetField = _useForm.resetField,
      trigger = _useForm.trigger,
      isDirty = _useForm.formState.isDirty,
      watch = _useForm.watch;

  var cleanFormData = (0, _react.useCallback)(function (data) {
    return _objectSpread(_objectSpread({}, data), {}, {
      message: _objectSpread({
        messageBody: data.message.messageBody,
        messageSubject: data.message.messageSubject,
        sendAsId: data.message.sendAsId
      }, (0, _ramda.reject)((0, _ramda.equals)(null))({
        templateId: data.message.templateId
      }))
    });
  }, []);
  var submitHandler = (0, _react.useCallback)(function (data) {
    onSubmit(cleanFormData(data), {
      isDirty
    });
  }, [onSubmit, isDirty, cleanFormData]);
  (0, _react.useEffect)(function () {
    if (batch) {
      var _batch$video;

      reset({
        [_messaging2.MessagingDataFields.Message]: _objectSpread(_objectSpread({}, batch.messaging), {}, {
          templateId: batch.messaging.templateId || null
        }),
        [_messaging2.MessagingDataFields.RecipientActions]: _objectSpread(_objectSpread({}, batch.recipientActions), {}, {
          [_messaging2.RecipientActionsFields.GifterAffidavit]: batch.recipientActions.captureAffidavit ? batch.recipientActions.gifterAffidavit : null,
          [_messaging2.RecipientActionsFields.GifterQuestion]: batch.recipientActions.captureQuestion ? batch.recipientActions.gifterQuestion : null
        }),
        [_messaging2.MessagingDataFields.MeetingHosts]: _objectSpread(_objectSpread({}, batch.meetingHosts), {}, {
          [_messaging2.MeetingHostsFields.IsAttendeeEnabled]: batch.meetingHosts.attendeeIds.length > 0
        }),
        [_messaging2.MessagingDataFields.VideoData]: (_batch$video = batch.video) !== null && _batch$video !== void 0 ? _batch$video : {
          [_messaging2.VideoDataFields.Type]: null,
          [_messaging2.VideoDataFields.Embed]: null,
          [_messaging2.VideoDataFields.Vidyard]: null
        }
      });
    }
  }, [reset, batch]);
  var meetingDateFieldName = "".concat(_messaging2.MessagingDataFields.RecipientActions, ".").concat(_messaging2.RecipientActionsFields.CaptureDate);
  var isMeetingRequired = watch(meetingDateFieldName);
  return /*#__PURE__*/_react.default.createElement("form", {
    onSubmit: handleSubmit(submitHandler)
  }, /*#__PURE__*/_react.default.createElement(_MessageDataController.default, {
    control: control,
    trigger: trigger,
    campaign: campaign,
    isMessagingPending: isMessagingPending,
    isGiftsCreatePending: isGiftsCreatePending
  }), /*#__PURE__*/_react.default.createElement(_ui.Divider, {
    mt: 2,
    mb: 2
  }), /*#__PURE__*/_react.default.createElement(_VideoDataController.default, {
    control: control,
    disabled: !(campaign !== null && campaign !== void 0 && campaign.videoOverrideEnabled)
  }), /*#__PURE__*/_react.default.createElement(_ui.Divider, {
    mt: 2,
    mb: 2
  }), /*#__PURE__*/_react.default.createElement(_RecipientActions.default, {
    control: control,
    resetField: resetField,
    campaign: campaign
  }), /*#__PURE__*/_react.default.createElement(_material.Collapse, {
    in: isMeetingRequired
  }, /*#__PURE__*/_react.default.createElement(_ui.Divider, {
    mt: 3,
    mb: 3
  }), /*#__PURE__*/_react.default.createElement(_MeetingHostsController.default, {
    control: control,
    campaign: campaign,
    isMessagingPending: isMessagingPending,
    isGiftsCreatePending: isGiftsCreatePending
  })), children);
};

var _default = /*#__PURE__*/(0, _react.memo)(MessagingForm);

exports.default = _default;